/*
 * VideoBanner = looping video
 * VideoPopup using froogaloop (in libs.js)
 *
 */


var videoBanner = {
  initialized: false,
  initBideo: function(url) {

    var _this = this;

    if ( Modernizr.mq("screen and (max-width:"+bp_cmsMobile+"px)") ) { 
      _this.$container.addClass('is-mobile');
      return; 
    }

    // if( $("#background_video").length && typeof Bideo !== "undefined" && Modernizr.mq("screen and (min-width:1025px)") ) {
    if( $("#background_video").length && typeof Bideo !== "undefined" ) {

      var videoArray = _this.splitUrl(url);
      var video = videoArray[0];
      var video_param = videoArray.length > 1 ? videoArray[1] : '';

      var bv = new Bideo();

      bv.init({
        // Video element
        videoEl: document.querySelector('#background_video'),
        // Container element
        container: document.querySelector('#videoContainer'),
        //isMobile: window.matchMedia('(max-width: 768px)').matches,
        // Resize
        resize: true,
        // Array of objects containing the src and type
        // of different video formats to add
        src: [
        {
          src: video + '.mp4' + video_param,
          type: 'video/mp4'
        },
        {
          src: video + '.webm' + video_param,
          type: 'video/webm'
        },
        {
          src: video + '.ogg' + video_param,
          type: 'video/ogg'
        }

        ],

        // What to do once video loads (initial frame)
        onLoad: function () {
          _this.$container.find('#video_cover').css('display','none');
          // if ( Modernizr.mq("screen and (max-width:"+bp_cmsMobile+"px)")) {
            _this.$container.parents('.banner-inner').find('.banner-img.desktop-hidden').css('display','none');
          // }


        }
      });
    }
  },
  loadScript: function(fn) {

    var src = "/wp-content/themes/liquid-cadigal/js/lib/bideo.min.js";
    var _this = this;

    var existing_script = document.querySelector('script[src="' + src + '"]');
    if (!existing_script) {

      var fjs = document.getElementsByTagName('script')[0];
      var script = document.createElement('script')

      script.src = src;

      // callback function once script loaded
      script.onload = fn;

      fjs.parentNode.insertBefore(script, fjs);

    } else {
      fn();
    }

  },
  splitUrl: function(url) {
    var urlArray = url.split('?');

    urlArray[0] = urlArray[0].replace(/\.[^/.]+$/, "");
    if(urlArray[1]) {
        urlArray[1] = '?' + urlArray[1];
    }

    return urlArray;
  },
  // resize: function() {
  //   var _this = this;

  //   // ===== Code below from Bideo.js ===== //

  //   // IE/Edge still don't support object-fit: cover
  //   // if ('object-fit' in document.body.style) { return; }

  //   // Video's intrinsic dimensions
  //   var w = _this.videoEl.videoWidth
  //     , h = _this.videoEl.videoHeight;

  //   // Intrinsic ratio
  //   // Will be more than 1 if W > H and less if H > W
  //   var videoRatio = (w / h).toFixed(2);

  //   // Get the container DOM element and its styles
  //   //
  //   // Also calculate the min dimensions required (this will be
  //   // the container dimentions)
  //   var containerStyles = window.getComputedStyle(_this.container)
  //     , minW = parseInt( containerStyles.getPropertyValue('width') )
  //     , minH = parseInt( containerStyles.getPropertyValue('height') );

  //   // If !border-box then add paddings to width and height
  //   if (containerStyles.getPropertyValue('box-sizing') !== 'border-box') {
  //     var paddingTop = containerStyles.getPropertyValue('padding-top')
  //       , paddingBottom = containerStyles.getPropertyValue('padding-bottom')
  //       , paddingLeft = containerStyles.getPropertyValue('padding-left')
  //       , paddingRight = containerStyles.getPropertyValue('padding-right');

  //     paddingTop = parseInt(paddingTop);
  //     paddingBottom = parseInt(paddingBottom);
  //     paddingLeft = parseInt(paddingLeft);
  //     paddingRight = parseInt(paddingRight);

  //     minW += paddingLeft + paddingRight;
  //     minH += paddingTop + paddingBottom;
  //   }

  //   // What's the min:intrinsic dimensions
  //   //
  //   // The idea is to get which of the container dimension
  //   // has a higher value when compared with the equivalents
  //   // of the video. Imagine a 1200x700 container and
  //   // 1000x500 video. Then in order to find the right balance
  //   // and do minimum scaling, we have to find the dimension
  //   // with higher ratio.
  //   //
  //   // Ex: 1200/1000 = 1.2 and 700/500 = 1.4 - So it is best to
  //   // scale 500 to 700 and then calculate what should be the
  //   // right width. If we scale 1000 to 1200 then the height
  //   // will become 600 proportionately.
  //   var widthRatio = minW / w;
  //   var heightRatio = minH / h;

  //   // Whichever ratio is more, the scaling
  //   // has to be done over that dimension
  //   if (widthRatio > heightRatio) {
  //     var new_width = minW;
  //     var new_height = Math.ceil( new_width / videoRatio );
  //   }
  //   else {
  //     var new_height = minH;
  //     var new_width = Math.ceil( new_height * videoRatio );
  //   }

  //   _this.videoEl.style.width = new_width + 'px';
  //   _this.videoEl.style.height = new_height + 'px';
  // },
  // hideCover: function() {
  //   this.$container.find('#video_cover').fadeOut();
  //   if ( Modernizr.mq("screen and (max-width:"+bp_cmsMobile+"px)")) {
  //     this.$container.parents('.banner-inner').find('.banner-img.desktop-hidden').fadeOut();
  //   }
  // },
  destroy: function() {
    var _this = this;

    if ( Modernizr.mq("screen and (max-width:"+bp_cmsMobile+"px)")) {
      // _this.$container.parents('.banner-inner').find('.banner-img.desktop-hidden').fadeIn();
      _this.$container.parents('.banner-inner').find('.banner-img.desktop-hidden').css('display','block');
    } else {
      // _this.$container.find('#video_cover').fadeIn();
      _this.$container.find('#video_cover').css('display','block');
    }

    // _this.videoEl.removeEventListener('loadedmetadata',_this.resize.bind(_this));
    // _this.videoEl.removeEventListener('play', _this.hideCover.bind(_this));

    _this.initialized = false;
  },
  init: function() {

    var _this = this;

    _this.videoEl = document.querySelector('#background_video');
    _this.container = document.querySelector('#videoContainer');

    _this.$videoEl = $('#background_video');
    _this.$container = $('#videoContainer');

    // save video markup
    _this.videoMarkup = $("<div />").append(_this.$videoEl.clone()).html();

    // save video urls (desktop and mobile)
    _this.desktop_url = _this.$videoEl.attr('data-desktop-loop');
    _this.mobile_url = _this.$videoEl.attr('data-mobile-loop');

    if ( _this.initialized ) { return; }

    var init_fn = function() {

      var url = Modernizr.mq("screen and (max-width:"+bp_cmsMobile+"px)") ? _this.mobile_url : _this.desktop_url;

      _this.initBideo(url);

      $(window).smartresize(function () {

        // if ($("#background_video").length > 0) { 
        //   $("#background_video").remove(); 
        //   _this.$container.append(_this.videoMarkup);
        // }

        var isMobile = Modernizr.mq("screen and (max-width:"+bp_cmsMobile+"px)");
        
        // Mobile
        if ( isMobile && !_this.$container.hasClass('is-mobile') ) {
          if ($("#background_video").length > 0) { 
            $("#background_video").remove(); 
            _this.$container.append(_this.videoMarkup);
          }
          // _this.$container.parents('.banner-inner').find('.banner-img.desktop-hidden').fadeIn();
          _this.$container.parents('.banner-inner').find('.banner-img.desktop-hidden').css('display','block');
          _this.$container.addClass('is-mobile');

          var url = Modernizr.mq("screen and (max-width:"+bp_cmsMobile+"px)") ? _this.mobile_url : _this.desktop_url;
          _this.initBideo(url);
        } 
        // Desktop
        else if (!isMobile && _this.$container.hasClass('loading') || !isMobile && _this.$container.hasClass('is-mobile') ) {
          if ($("#background_video").length > 0) { 
            $("#background_video").remove(); 
            _this.$container.append(_this.videoMarkup);
          }
          // _this.$container.find('#video_cover').fadeIn();
          _this.$container.find('#video_cover').css('display','block');
          _this.$container.removeClass('is-mobile');

          var url = Modernizr.mq("screen and (max-width:"+bp_cmsMobile+"px)") ? _this.mobile_url : _this.desktop_url;
          _this.initBideo(url);
        }
      })
    }

    _this.loadScript(init_fn);


    _this.initialized = true;
  }
}

var videoHomePopup = {
  resizeIframe: function() {
    var _this = this;

    if ( _this.iframe.length < 1 ) { return; }

    var container = _this.iframe.parent('.video-container');

    var containerHeight = container.height();
    var newWidth = container.width();

    // Resize video according to its aspect ratio
    var newHeight = newWidth * _this.iframe.data('iframeRatio');

    // if video taller than window
    if ( newHeight > containerHeight ) {
      newHeight = containerHeight;
      newWidth = newHeight / _this.iframe.data('iframeRatio');
    }

    _this.iframe
      .width(newWidth)
      .height(newHeight)
      .css({
        'opacity': 1,
        'visibility': 'visible'
      });
  },
  closeModal: function() {
    var _this = this;
    _this.videoContainer.removeClass('on');
    // $('body').css('overflow-Y','initial');
    $('body').css('overflow-Y','');
    _this.pauseVideo();
  },
  playVideo: function(){
    var _this = this;
    this.player.api("play");
  },
  pauseVideo: function(obj){

    // if "this" is given as param
    var _this = obj == null ? this : obj;

    _this.player.api("pause");
  },
  hasIframeLoaded: function(iframe) {
    // Get a handle to the iframe element
    var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    var loaded = false;

    // Check if loading is complete
    if (  iframeDoc.readyState  == 'complete' ) {
        //iframe.contentWindow.alert("Hello");
        iframe.contentWindow.onload = function(){
            loaded = true;
            // alert("I am loaded");
        };
        // The loading is complete, call the function we want executed once the iframe is loaded
        // afterLoading();
        // return;
    } 

    return loaded;

    // If we are here, it is not loaded. Set things up so we check   the status again in 100 milliseconds
    window.setTimeout(checkIframeLoaded, 100);
  },
  init: function() {

    var _this = this;
    if ( $("#popup_video_container").length < 1 ) {return; }

    _this.videoContainer = $("#popup_video_container");

    // Iframe/player variables
    _this.iframe = _this.videoContainer.find('iframe');
    var iframe_el = _this.iframe[0];
    _this.player = $f(iframe_el);


    if (_this.iframeLoaded == true ) {
      handleLoad();
    } else {
      _this.iframe.on('load', function(){
        handleLoad();
      });
    }

    function handleLoad() {
      // ==== Play/Pause video for preloading (Issue on FF: sound stays on)
      // _this.playVideo();
      // setTimeout(_this.pauseVideo(_this), 400);

      // ==== Resize iframe

      // Figure out and save aspect ratio
      _this.iframe
        .data('iframeRatio', _this.iframe.height() / _this.iframe.width())
        // .data('iframeRatio', iframe.height / iframe.width)
        // and remove the hard coded width/height
        .removeAttr('height')
        .removeAttr('width')
        .css('margin','0 auto');

      // When the window is resized
      $(window).smartresize(function () {
          _this.resizeIframe();
      })
      _this.resizeIframe();
    }

    // Open on click on button
    $('#banner_video_btn').click(function(){
        _this.videoContainer.addClass('on');
        $('body').css('overflow-Y','hidden');
        _this.playVideo();
    })

    // close poup on click on icon or black overlay
    _this.videoContainer.find('#close_video').on("click", function(e) {
        // _this.videoContainer
        e.stopPropagation();
        e.preventDefault();
        _this.closeModal();
    });
    _this.videoContainer.on("click", function(e) {
        // _this.videoContainer
        e.stopPropagation();
        e.preventDefault();
        _this.closeModal();
    });
    // close popup on press escape
    $(document).keyup(function(e) {
        e.stopPropagation();
        e.preventDefault();
        if (e.keyCode == 27) { // escape key
           _this.closeModal();
        }
    });
  },
  destroy: function() {
    var _this = this;

    _this.player.removeEvent();

    // destroy click events
    $('#banner_video_btn').off().click();
    _this.videoContainer.off().click();
    _this.videoContainer.find('#close_video').off().click();
  }
}


 
// BACKGROUND LOOPING VIDEO  (backgroung image module)
// using bideo js
var loopingVideo = {
  initialized: false,
  draw: function(videoContainer) {
    var _this = this;

    // if ( videoContainer.length < 1 || typeof Bideo == "undefined") { return; }
    if ( videoContainer.length < 1 ) { return; }

    //var video_src = 'http://res.cloudinary.com/socialmanage/video/upload/c_limit,eo_17,f_auto,so_07,w_1600/v1487819894/M3565-720_aur3yh'; 
    // var video_src = videoContainer.attr('data-src'); 
    var video_url = videoContainer.attr('data-url'); 

    var videoArray = _this.splitUrl(video_url);
    var video_src = videoArray[0];
    var video_param = videoArray.length > 1 ? videoArray[1] : '';

    // var param_attr = videoContainer.attr('data-params'); 
    // if ( typeof param_attr !== typeof undefined && param_attr !== false ) {
    //   var video_param = param_attr;
    // } else {
    //   var video_param = '';
    // }
     
    // var $videoContainer = $('.videoLoop');
    // var videoContainer = $('.videoLoop')[0];
    // var videoEl = $videoContainer.find('video')[0];

    var container = videoContainer[0];
    var video = videoContainer.find('video')[0];

    // this.video = video;

    // if (  Modernizr.mq("screen and (min-width:1025px)") ) {
    if (  typeof Bideo !== "undefined" ) {

      var bv = new Bideo();

      // autoplay
      // var play = true;
      // var attr = $(video).attr('paused');
      // if (typeof attr !== typeof undefined && attr !== false) {
      //   play = false;
      // }
      
      bv.init({
        // Video element
        // videoEl: document.querySelector('#banner_video'),
        videoEl: video,
        // Container element
        // container: document.querySelector('#banner_video_container'),
        container: container,
        //isMobile: window.matchMedia('(max-width: 768px)').matches,
        // Autoplay
        // autoplay: false,
        // Resize
        resize: true,
        // Array of objects containing the src and type
        // of different video formats to add
        src: [
        {
          src: video_src + '.mp4' + video_param,
          type: 'video/mp4'
        },
        {
          src: video_src + '.webm' + video_param,
          type: 'video/webm'
        },
        {
          src: video_src + '.ogg' + video_param,
          type: 'video/ogg'
        }
        
        ],

        // What to do once video loads (initial frame)
        onLoad: function () {
        }
      });
    } else {
      // replace video with placeholder
    }
  },
  splitUrl: function(url) {
    var urlArray = url.split('?');

    urlArray[0] = urlArray[0].replace(/\.[^/.]+$/, "");
    if(urlArray[1]) {
        urlArray[1] = '?' + urlArray[1];
    }

    return urlArray;
  },
  loadScript: function(fn) {

    // var src = "/js/lib/bideo.min.js";
    var src = "/wp-content/themes/liquid-cadigal/js/lib/bideo.min.js";
    var _this = this;

    var existing_script = document.querySelector('script[src="' + src + '"]');
    if (!existing_script) {

      var fjs    = document.getElementsByTagName('script')[0];
            var script     = document.createElement('script')
      
            script.src = src;
      
      // callback function once script loaded
            script.onload = fn;

            fjs.parentNode.insertBefore(script, fjs);

    } else {
      fn();
    }

  },
  init: function() {

    var _this = this;
    _this.container = $('.background-image-section .videoLoop');

    if ( _this.initialized ) { return; }
    if ( !_this.container.length && !$('.lazy-scroll.video').length ) { return; }
    if ( !_this.container.length ) { return; }


    var init_fn = function() {

      _this.container.each(function(){
        _this.draw($(this));
      })

      $(window).smartresize(function () { 
        _this.container.each(function(){
          _this.draw($(this));
        })
      })
    }

    _this.loadScript(init_fn);

    _this.initialized = true;
  },
  destroy: function() {
    var _this = this;

    if ( ! _this.container.length ) { return; }

    _this.container.each(function(){
      $(this).find('video').html('');
      $(this).find('video').style = '';
    })

    $(window).smartresize(function () { 
      _this.container.each(function(){
        _this.draw($(this));
      })
    })
    _this.initialized = false;
  }
}





// EMBED VIDEOS: image > on click open video in fullscreen modal

var embedVideo_instances = [];

var initEmbedVideos = function() {

  var videos = $('.video-section');

  if ( videos.length ) {
    videos.each(function(){
      embedVideo_instances.push(initEmbedVideo($(this)));
    })
  }
}
var destroyEmbedVideos = function() {
  var instance;
  while (embedVideo_instances.length > 0) {
    instance = embedVideo_instances.shift();
    instance.destroy();
  }
}

// Using Froogaloop
var initEmbedVideo = function (container) {
  var embedVideo = {
    resizeIframe: function() {
      var _this = this;

      _this.iframe
        .data('iframeRatio', _this.iframeH / _this.iframeW)
        .removeAttr('height')
        .removeAttr('width')
        .css('margin','0 auto');

      if ( _this.iframe.length < 1 ) { return; }

      var container = _this.iframe.parent('.video-container');

      var containerHeight = container.height();
      var newWidth = container.width();

      // // Resize video according to its aspect ratio
      var newHeight = newWidth * _this.iframe.data('iframeRatio');


      // // if video taller than window
      if ( newHeight > containerHeight ) {
        newHeight = containerHeight;
        newWidth = newHeight / _this.iframe.data('iframeRatio');
      }

      _this.iframe
        .width(newWidth)
        .height(newHeight)
        // .css({
        //   'opacity': 1,
        //   'visibility': 'visible'
        // })
        ;
        _this.iframe.removeClass('is-hidden');
    },
    closeModal: function() {
      var _this = this;
      _this.popup.removeClass('on'); 
      // $('body').css('overflow-Y','initial');
      $('body').css('overflow-Y','');
      _this.popup.remove();
    },
    init: function(){
      var _this = this;
      if (container.length < 1) return;

      _this.container = container;

      _this.placeholder = _this.container.find('.video-placeholder-img');
      _this.popupMarkup = '<div class="cms-video-popup"><div class="close">'+close_icon+'</div><div class="inner"><div class="video-container"></div></div></div>';
      // _this.popup = _this.container.find('.cms-video-popup');

      _this.url = _this.placeholder.attr('data-video-src');

      _this.iframeW = _this.placeholder.attr('data-width') == '' ? '560' : _this.placeholder.attr('data-width');
      _this.iframeH = _this.placeholder.attr('data-height') == '' ? '315' : _this.placeholder.attr('data-height');


      // on click on image: show popup.
      _this.placeholder.on("click", function(e) { 
        e.stopPropagation();
        e.preventDefault();

        // append popup
        $('body').append(_this.popupMarkup);
        _this.popup = $(".cms-video-popup");
        // var video_close_icon = '<div class="close_video">'+close_icon+'</div>';
        // _this.popup.append(video_close_icon);

        // create iframe
        var iframe = '<iframe class="is-hidden" width="'+_this.iframeW+'" height="'+_this.iframeH+'" src="' + _this.url + '" frameborder="0"></iframe>';
        _this.popup.find('.video-container').append(iframe);
        _this.iframe = _this.popup.find('iframe');


        // _this.iframe.on('load', function(){ 
        //   _this.resizeIframe();
        //   // var container = _this.iframe.parent('.video-container');
        //   // var containerHeight = container.height();
        // });
        _this.resizeIframe();

        // var video = _this.popup.find('iframe');

        // // show popup and play video
        _this.popup.addClass('on'); 
        $('body').css('overflow-Y','hidden');

        // // add autoplay
        if ( ('youtube').indexOf(_this.url) ) {
          var sign = _this.url.toLowerCase().indexOf("?") >= 0 ? '&' : '?';
          iframe_src = _this.url + sign + "autoplay=1";
        } else if ( ('vimeo').indexOf(_this.url) ) {
          var sign = _this.url.toLowerCase().indexOf("?") >= 0 ? '&' : '?';
          iframe_src = _this.url + sign + "autoplay=1";
        }
        // video[0].src = iframe_src;
        _this.iframe.attr('src',iframe_src);

        // close poup on click on icon
        _this.popup.on("click", function(e) { 
          // video_container
          e.stopPropagation();
          e.preventDefault();
          _this.closeModal();
        });
        // close popup on press escape
        $(document).keyup(function(e) {
          e.stopPropagation();
          e.preventDefault();
          if (e.keyCode == 27) { // escape key maps to keycode `27`
            _this.closeModal();
          }
        })

      }) // en click

      return _this;
    },
    destroy: function() {
    }
  }

  return embedVideo.init(container);
}


